import { useTranslation } from 'react-i18next';
import { FileItem } from '../FileItem';
import { UploadItemTypeEnum } from '@/Domain/enum/UploadItemType.enum';
import { UploadStatusEnum } from '@/Domain/enum/UploadStatus.enum';
import { UploadFile } from '@/Domain/store/upload.store';

type Props = {
  files: UploadFile[];
  getFileIcon: (fileName: string, fileType?: UploadItemTypeEnum) => string;
  getFileSizeText: (fileSize: number) => string;
};

export const FilesList = ({ files, getFileIcon, getFileSizeText }: Props) => {
  const { t } = useTranslation(['knowledge_base']);

  if (files.length === 0) {
    return (
      <div className="py-4 text-center text-sm text-foreground-subtle">
        {t('modals.status_modal.no_files')}
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {files.map((file, index) => (
        <FileItem
          key={`status-file-${file.id}-${index}`}
          name={file.name}
          size={file.size}
          error={
            file.status === UploadStatusEnum.ERROR
              ? (file.errorMessage ?? t('modals.status_modal.failed'))
              : undefined
          }
          status={file.status}
          index={index}
          getFileIcon={getFileIcon}
          getFileSizeText={getFileSizeText}
          showStatus={true}
          showRemoveButton={false}
          fileType={
            file.type === UploadItemTypeEnum.URL ? UploadItemTypeEnum.URL : UploadItemTypeEnum.FILE
          }
        />
      ))}
    </div>
  );
};
